import { createUniqueID, strToEl } from '../functions/utils';
import { createPopper } from '@popperjs/core';

export default class Tooltip {
  constructor(element) {
    this.passedElement = element;
    this.showEvents = ['mouseover', 'touchstart'];
    // this.hideEvents = [];
    this.hideEvents = ['mouseout', 'blur', 'touchend'];
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this._createTooltip();
      this.createEventListeners();
    }
  }

  getTooltipOptionsFromElement = () => {
    const tooltipText = this.passedElement.hasAttribute('data-text') && this.passedElement.getAttribute('data-text') != '' ? this.passedElement.getAttribute('data-text') : 'Default text';
    const tooltipPosition = this.passedElement.hasAttribute('data-position') && this.passedElement.getAttribute('data-position') != '' ? this.passedElement.getAttribute('data-position') : 'top';
    const tooltipId = createUniqueID('tooltip');

    this.tooltipText = tooltipText;
    this.tooltipPosition = tooltipPosition;

    return {
      tooltipText,
      tooltipPosition,
      tooltipId,
    }
  }



  _createTooltip = () => {
    let options = this.getTooltipOptionsFromElement();
    let flashcardId = this.passedElement.getAttribute('data-src').split('#')[1];
    let card = document.querySelector(`#${flashcardId}`);
    let title = (card !== null) ? card.querySelector('.flashcard__title').innerHTML : "";
    let content = (card !== null) ? card.querySelector('.flashcard__content').innerHTML : "";
    this.createTemplateElement(options.tooltipId, content, options.tooltipPosition, title);
    this.passedElement.setAttribute('described-by', options.tooltipId);
    //this.passedElement.removeAttribute("href");



    const tooltipPopperRef = createPopper(this.passedElement, this.tooltipTemplate, {
      placement: options.tooltipPosition
    });

    this.tooltipPopperRef = tooltipPopperRef;
  }



  createTemplateElement = (id, text, direction, title) => {
    let templateString = `
        <div id="${id}" class="tooltip tooltip--${direction}" role="tooltip">
          <div class="arrow"></div>
          <div class="tooltip-inner">
            <h4 class="tooltip__title">${title}</h4>
            ${text}
          </div>
        </div>`

    let tooltip = strToEl(templateString);
    this.tooltipTemplate = tooltip;
  }

  createEventListeners = () => {
    this.showEvents.forEach(event => {
      this.passedElement.addEventListener(event, this.show);
    });

    this.hideEvents.forEach(event => {
      this.passedElement.addEventListener(event, this.hide);
    });

    this.createBodyEvent();
  }

  createBodyEvent = () => {
    document.body.addEventListener('click', (event) => {
      let isInPath = false;
      
      if ( event.path ) {
        event.path.forEach((p) => {
          if (p === this.tooltipTemplate || p === this.passedElement) {
            isInPath = true;
          }
        });
      }
      
      if (!isInPath) {
        if (document.documentElement.clientWidth < 792) {
          this.destroy();
        }
      }
    });
  }

  removeEventListeners = () => {
    this.showEvents.forEach(event => {
      this.passedElement.removeEventListener(event, this.show);
    });

    this.hideEvents.forEach(event => {
      this.passedElement.removeEventListener(event, this.hide);
    });
  }

  show = () => {
    if ( event.type == 'click' ) {
      event.preventDefault();
    }
    this._createTooltip();
    this.tooltipPopperRef.update();
    document.body.append(this.tooltipTemplate);
    this.tooltipTemplate.classList.add('show');
  }

  hide = () => {
    if ( event.type == 'click' ) {
      event.preventDefault();
    }
    this.tooltipTemplate.classList.remove('show');
    this.destroy();
  }

  destroy = () => {
    if (this.tooltipPopperRef) {
      this.tooltipPopperRef.destroy();
      this.tooltipPopperRef = null;
    }
  }

  dismantle = () => {
    this.destroy();
    this.removeEventListeners();
    this.passedElement = null;
    this.tooltipText = null;
    this.tooltipPosition = null;
    this.tooltipTemplate = null;
    this.tooltipPopperRef = null;
    // Finally
    this.initialised = false;
  }
}
